module.exports = __webpack_public_path__ + "static/media/update_variable.0116d35b.svg";